/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_New_Contact_PhoneInputs */

const en_cad_field_new_contact_phone = /** @type {(inputs: Cad_Field_New_Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New contact phone (optional)`)
};

const ja_cad_field_new_contact_phone = /** @type {(inputs: Cad_Field_New_Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい連絡先電話番号（任意）`)
};

const fr_cad_field_new_contact_phone = /** @type {(inputs: Cad_Field_New_Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau téléphone de contact (optionnel)`)
};

const de_cad_field_new_contact_phone = /** @type {(inputs: Cad_Field_New_Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Kontakt-Telefonnummer (optional)`)
};

/**
* | output |
* | --- |
* | "New contact phone (optional)" |
*
* @param {Cad_Field_New_Contact_PhoneInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_new_contact_phone = /** @type {((inputs?: Cad_Field_New_Contact_PhoneInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_New_Contact_PhoneInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_new_contact_phone(inputs)
	if (locale === "ja") return ja_cad_field_new_contact_phone(inputs)
	if (locale === "fr") return fr_cad_field_new_contact_phone(inputs)
	return de_cad_field_new_contact_phone(inputs)
});